'use strict';

var dim;

module.exports = function() {
	if (dim === undefined) {
		var div = document.createElement("div");
		var s = div.style;
		s.width='100px';
		s.height='100px';
		s.overflow='scroll';
		s.position='absolute';
		document.body.appendChild(div);
		dim = {
			width: div.offsetWidth - div.clientWidth,
			height: div.offsetHeight - div.clientHeight
		};
		document.body.removeChild(div);
	}
	return dim;
};